module.exports = __webpack_public_path__ + "media/images/icon_afi-713d78ee5c4cb81ab9926b4489432f92.svg";